import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { fetchPost } from "../utils";

export default function UploadFile({ file }) {
  const [nextFile, setNextFile] = useState(file);
  const [nextUpload, setNextUpload] = useState(file);
  const [redirect, setRedirect] = useState(null);
  const [uploading, setUploading] = useState(false);

  const submit = async () => {
    setUploading(true);
    console.log("nextUpload");
    console.log(nextUpload);
    const data = new FormData();
    data.append("file", nextUpload);

    //console.log("data");
    //console.log(data.get("file"));
    let body;
    try {
      const response = await fetch("/api/s3", {
        method: "POST",
        body: data,
      });
      body = await response.json();
    } catch (err) {
      setUploading(false);
      console.error("ERROR_SAVING_FILE");
      console.error(err);
    }
    //const { body } = await fetchPost({
    //data: { file: JSON.stringify(data.get("file")) },
    //url: "/api/s3",
    //onError: console.error,
    //});

    setUploading(false);
    if (body) {
      setRedirect("/files");
      console.log("body");
      console.log(body);
    }
  };

  return redirect ? (
    <Redirect to={redirect} />
  ) : (
    <>
      <h1>Upload a file to your HUB</h1>
      <br />
      <label htmlFor="file">Upload file:</label>
      <br />
      <input
        type="file"
        id="file"
        value={nextFile}
        onChange={(e) => {
          e.preventDefault();
          const { target } = e;
          setNextFile(target.value);
          setNextUpload(target.files[0]);
        }}
      />
      <br />
      <br />
      <button disabled={uploading} onClick={submit}>
        Submit
      </button>
      {uploading && "uploading..."}
    </>
  );
}
